import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import createBrowserHistory from 'history/createBrowserHistory';

import RequireAuth from '../components/auth/require_auth';
import Home from '../components/pages/Home';
import Login from '../components/pages/Login';
import NoMatch from '../components/pages/NoMatch';


const history = createBrowserHistory();
const Routes = () => (
    <div>
        <BrowserRouter hisotry={history}>
            <Switch>
                <Route exact path="/" render={() => (<Redirect to="/home" />)} />   
                <Route path="/home" component={RequireAuth(Home)} />
                {/* <Route path="/home" component={Home} /> */}
                <Route path="/login" component= {Login} />
                <Route component={NoMatch} />
            </Switch>
        </BrowserRouter>
    </div>
);

export default Routes

  